import { render, staticRenderFns } from "./NotificationsSettingsFormStaticPages.vue?vue&type=template&id=8c24cb22"
import script from "./NotificationsSettingsFormStaticPages.vue?vue&type=script&lang=js"
export * from "./NotificationsSettingsFormStaticPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports